(function () {
  class RisingBubbles extends PIXI.Container {
    constructor() {
      super();
      this._completeCallback;
      StateMachine.Create(this);

      this._emitter = undefined;
      this._lifetime = 0;
      this._clear = false;
      this._loaded = false;
    }

    initialise() {
      const self = this;
      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
      Reflex.registerEventHandler('orientationChange', this.orientationChange.bind(this));
    }

    startBubbles() {
        this._emitter.particleEmitter.emit = true;
    }

    stopBubbles() {
      this._emitter.particleEmitter.emit = false;
    }

    onLayoutComplete() {
      this._emitter = particleManager.createEmitter('bubbles_emitter', this, 0, 0, false);
      this._emitter.particleEmitter.emit = false;
      this._lifetime = this._emitter.particleEmitter.maxLifetime;
      this._emitter.x = 0;
      this._loaded = true;
      this.orientationChange();
    }

    orientationChange() {
      if (!this._loaded) {
        return;
      }

      if (this._clear) {
        this._emitter.particleEmitter.cleanup();
      }

      this._emitter.y = systemData.isLandscape ? 720 : 1280;

      const lifetime = systemData.isLandscape ? this._lifetime : this._lifetime * 2;

      this._emitter.particleEmitter.minLifetime = lifetime;
      this._emitter.particleEmitter.maxLifetime = lifetime;
    }

    overrideParams(params) {
      this._emitter.particleEmitter.startScale.value = params.scale;
      this._emitter.particleEmitter.startSpeed.value = params.startSpeed;
      this._emitter.particleEmitter.startSpeed.next.value = params.endSpeed;
      this._emitter.particleEmitter._frequency = params.frequency;
      this._emitter.particleEmitter.particleBlendMode = params.blend;
      this._clear = params.clear;
      this._lifetime = params.lifetime;

      this.orientationChange();
    }
  }

  create = function (json) {
    return new RisingBubbles();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('risingBubbles', create, initialise, getFilesRequired);
})();
